<!-- メイン -->
<div class="main">
  <!-- メインコンテンツ -->
  <div class="main-content" [class.platform-large-text]="getTextSize()">
    <!-- A200系共通部品_Steps -->
    <app-a200-steps></app-a200-steps>

    <!-- 入会申請(A201) -->
    <div *ngIf="!confirmationFlag">
      <!-- 注意テキスト -->
      <div class="a201-warningText">
        申請には代表者捺印した
        <a href="https://naikakufu-prod-etc.s3.ap-northeast-1.amazonaws.com/%E8%AA%93%E7%B4%84%E6%9B%B8.pdf"
          target="_blank">
          誓約書
          <i class="pi pi-clone"></i>
        </a>
        をスキャンしたPDFファイルのアップロードが必要です。予めご準備ください。<br />
        以下の項目に必要事項を記載後、「確認画面へ進む」ボタンをクリックしてください。<br />
        <label class="warning platform-warning-text">
          ※【必須】の項目は入力必須項目です。必ずご記載ください。
        </label>
      </div>

      <!-- タイトル -->
      <div class="title">
        <h1>入会申請</h1>
      </div>

      <!-- 利用規約 -->
      <div class="rule">
        <div class="ruleText">
          本サービスの利用には以下の規約に同意する必要があります。
        </div>
        <p-accordion expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
          <p-accordionTab header="地方創生ＳＤＧｓ官民連携プラットフォームサイト利用規約を開く" [(selected)]="ruleCheck">
            <span class="ruleTitle">地方創生ＳＤＧｓ官民連携プラットフォームサイト利用規約</span><br />
            <br />
            <span>地方創生ＳＤＧｓ官民連携プラットフォーム（以下「プラットフォーム」といいます。）は、「地方創生ＳＤＧｓ官民連携プラットフォームサイト」（以下「当サイト」といいます。）をご利用いただくために、以下のとおり利用規約（以下「本規約」といいます。）を定めております。</span><br />
            <br />
            <span class="ruleTitle">第１条（総則）</span><br />
            <span>１．本規約は、当サイト上でプラットフォームが提供するサービス（当サイト上でプラットフォームが提供するサービスの総称をいい、以下「本サービス」といいます。）を利用する全てのユーザー（以下「ユーザー」といいます。）とプラットフォームとの一切の関係について適用されます。</span><br />
            <br />
            <span>２．ユーザーは、本サービスを利用することにより、<a href="https://future-city.go.jp/data/pdf/platform/platform1.pdf"
                target="_blank">「地方創生ＳＤＧｓ官民連携プラットフォーム規約」</a>、<a href="https://future-city.go.jp/sdgs/policy.html"
                target="_blank">「プライバシーポリシー」</a>、及び本規約の内容を遵守することを承諾したものとみなします。</span><br />
            <br />
            <span class="ruleTitle">第２条（本規約の変更・改定）</span><br />
            <span>１．プラットフォームは、本規約を随時変更・改定することができるものとします。</span><br />
            <br />
            <span>２．本規約を変更・改定する場合には、プラットフォームは、当サイトにて変更後の内容並びにその効力発生時期を表示し、またはプラットフォームが定める方法によりユーザーに周知します。</span><br />
            <br />
            <span class="ruleTitle">第３条（本サービスの変更・廃止）</span><br />
            <span>プラットフォームは、本サービスの内容の全部又は一部をユーザーへの事前の通知なくして変更できるものとします。また、プラットフォームは本サービスの全部又は一部を、当サイト上に掲示するなど、プラットフォームが適当と認める告知方法により一定の予告期間をおいて、停止又は廃止できることとします。ただし、緊急の場合には、予告期間なしに停止又は廃止する場合があります。</span><br />
            <br />
            <span class="ruleTitle">第４条（本サービスの一時的な中断）</span><br />
            <span>プラットフォームは、次の事由によりユーザーに事前に通知することなく一時的に本サービスの提供を中断することがあります。</span><br />
            <span>（１）プラットフォームの使用する設備やシステム等の障害、保守、点検、修理、メンテナンス等の事由による場合。</span><br />
            <span>（２）火災、停電等により本サービスの提供ができなくなった場合。</span><br />
            <span>（３）地震、噴火、洪水、津波、台風、大雪等の天変地異により本サービスの提供ができなくなった場合。</span><br />
            <span>（４）戦争、動乱、暴動、騒乱、テロ、労働争議等により本サービスの提供ができなくなった場合。</span><br />
            <span>（５）その他、当サイトの運用上又は技術上、プラットフォームが本サービスの提供の一時的な中断を必要と判断した場合。</span><br />
            <br />
            <span class="ruleTitle">第５条（利用環境の整備と自己責任原則）</span><br />
            <span>１．ユーザーは、自己の責任と費用負担において、本サービスを利用するために必要な機器、ソフトウェア、通信手段等を準備し、それらの情報セキュリティを確保するとともに、それらを適切に設置及び操作するものとします。</span><br />
            <br />
            <span>２．ユーザーは、ユーザーによる本サービスの利用及び本サービスを利用してなされた一切の行為（第１４条第６項により、ユーザーによる利用又は行為とみなされる他者の利用や行為を含みます。以下同様とします。）とその結果について一切の責任を負うものとします。また、ユーザーは、本サービスの利用により本サービス又は第三者に対して損害を与えた場合（ユーザーが、本規約上の義務を履行しないことによりプラットフォーム又は第三者が損害を被った場合を含みます。）には、自己の責任と費用負担において一切の損害を賠償するものとします。</span><br />
            <br />
            <span>３．プラットフォームは、ユーザーが、本サービスや当サイト上のコンテンツ又はプラットフォームの他の情報及び通信システムに対し、不具合や損害を発生させ、変更を加え、又はウイルスに感染させること及びそれらの恐れがある行為を行うことを禁止します。</span><br />
            <br />
            <span class="ruleTitle">第６条（権利の帰属・情報の無断使用の禁止）</span><br />
            <span>１．プラットフォームが本サービスによって提供する情報、その他の当サイトを構成する内容の全部又は一部に係る著作権、商標権その他の知的財産権、肖像権、パブリシティ権、その他の一切の権利は、<a
                href="https://future-city.go.jp/sdgs/copyright.html"
                target="_blank">「リンク、著作権等について」</a>に則ります。</span><br />
            <br />
            <span>２．ユーザーは、本サービスの目的、本規約及び関連する法令が許容する範囲内においてのみ、本サービスを利用することができ、また、ユーザー自身が利用するためにのみコンテンツをコピー、ダウンロード又は印刷することができます。</span><br />
            <br />
            <span>３．ユーザーは、本サービスが提供する情報、その他の当サイトを構成する内容の全部又は一部に対し、プラットフォーム又は正当な権利者の事前の承諾なく、譲渡、編集、翻案、使用、複製、転載、公衆送信、転送等について<a
              href="https://future-city.go.jp/sdgs/copyright.html"
              target="_blank">「リンク、著作権等について」</a>に従うこととします。また、方法及び目的の如何を問わず第１項に規定する権利を侵害することはできません。なお、著作権法第32条に定める適切な範囲での引用は認められるものとします。</span><br />
            <br />
            <span>４．第１３条に定める手続によりプラットフォームが入会申請を承認したユーザー（以下「会員」といいます。）が本サービスの利用に当たり投稿した情報についての権利は、当該情報の著作者又は著作権者、その他当該権利に関する正当な権限を有する者に帰属するものとします。</span><br />
            <br />
            <span>５．会員は、本サービスの利用に当たり情報を投稿することによって、プラットフォームに対して日本の国内外において無償で非独占的に当該投稿を使用、複製、編集等を行う権利（著作権法第２１条ないし第２８条の権利及び商用利用を含みます。）を許諾したものとみなします。当該会員からプラットフォームに許諾される権利には、第２項に定める態様により他のユーザーが当該投稿を使用することをプラットフォームが認める権利等、プラットフォームから第三者に対する再利用許諾権を含みます。なお、会員は、自らの投稿について、プラットフォーム又はプラットフォームから再利用許諾を受けた第三者に対して著作者人格権を行使せず、又は第三者に著作者人格権を行使させないものとします。</span><br />
            <br />
            <span>６．会員が本サービスの利用に当たり投稿する情報について、当該投稿を行う会員は、複製権等の著作権法上の権利、その他の投稿及び前項に基づく権利の許諾を行うために必要となる全ての権利を有しており、第三者の権利を何ら侵害していないことを保証するものとします。</span><br />
            <br />
            <span>７．プラットフォームは、ユーザーが本条および<a
              href="https://future-city.go.jp/sdgs/copyright.html"
              target="_blank">「リンク、著作権等について」</a>に違反しプラットフォームの権利を侵害した場合に、違反行為を差し止める権利、違反行為によって生じたものの使用を差し止める権利、違反行為によって生じた結果を除去することを求める権利及び違反行為による損害等の賠償を請求する権利を有します。なお、プラットフォームは、ユーザーが第三者（他のユーザーを含みます。）の情報を提供者の同意なくして利用した場合、当該利用行為を提供者に代わり差し止め、又は除去する義務を負わず、また、提供者に対し何らの損害賠償責任を負うものではなく、提供者が自らの責任と費用負担において、当該利用行為者に対する適切な措置及び対応をとるものとします。</span><br />
            <br />
            <span class="ruleTitle">第７条（不適切な投稿・行為の禁止）</span><br />
            <span>１．ユーザーは、本サービスを利用するに当たり、故意又は過失を問わず、次の各号に該当し、又はその恐れがある内容の投稿及び行為を、その形態の如何にかかわらず、行うことはできません。</span><br />
            <span>（１）公序良俗に反する投稿及び行為。</span><br />
            <span>（２）犯罪的行為及びその助長又はその実行を暗示する投稿及び行為。</span><br />
            <span>（３）プラットフォーム、他のユーザー又は第三者の知的財産権（著作権、意匠権、特許権、実用新案権、商標権及びノウハウが含まれますが、これらに限定されません。）その他の財産権、プライバシー権、肖像権、その他の権利を侵害する投稿及び行為並びにその他のプラットフォーム、他のユーザー又は第三者に対して経済的損害を与える行為。</span><br />
            <span>（４）プラットフォーム、他のユーザー若しくは第三者を誹謗中傷し、その名誉を傷つけ、その他の精神的損害を与える恐れがあり、プラットフォーム、他のユーザー若しくは第三者の評判を毀損し、信用不安を引き起こす恐れがあり、又はプラットフォーム、他のユーザー若しくは第三者に迷惑をかけ若しくは不快感を与える投稿及び行為。</span><br />
            <span>（５）法令、これに準ずるガイドライン、準則等に反する投稿及び行為。</span><br />
            <span>（６）選挙の事前運動、選挙運動又はこれらに類似する投稿及び行為並びに公職選挙法に抵触する投稿及び行為。</span><br />
            <span>（７）自己又は第三者の単なる商品又はサービスの営業活動を目的とした投稿及び行為、その他本サービス又は当サイトを目的外で利用すること。</span><br />
            <span>（８）無限連鎖講及びマルチ商法又はそれに類し、若しくはその恐れのある投稿及び行為、並びにプラットフォームが無限連鎖講及びマルチ商法又はそれに類し、若しくはその恐れのあるものと判断する内容を掲載する投稿及び行為。</span><br />
            <span>（９）商品投資・集団投資スキームへの勧誘（公益を目的としたものを除く。）又はこれらに類するビジネス、若しくはその恐れのある投稿及び行為、並びにプラットフォームが商品投資・集団投資スキームへの勧誘（公益を目的としたものを除く。）又はそれに類し、若しくはその恐れのあるものと判断する内容を掲載する投稿及び行為。</span><br />
            <span>（１０）特定の宗教に関する布教活動又は反対活動等を目的にする投稿及び行為。</span><br />
            <span>（１１）人種、民族、信条、性別、社会的身分、居住場所、身体的特徴、病歴、教育、財産及び収入等を根拠にする差別、その他の差別を助長し又は想起させる投稿及び行為。</span><br />
            <span>（１２）当サイトのセキュリティホールやバグを利用する行為、人為的な高負荷アクセスを発生させる行為、他者の設備又は本サービス用設備（本サービスを提供するために利用される通信設備、通信回線、電子計算機、その他の機器及びソフトウェアをいいます。）に無権限でアクセスし、又はその利用若しくは運営に支障を与える行為、本サービス及び当サイトを逆アセンブル、逆コンパイル又はリバースエンジニアリングする行為、コンピューターウイルス等の不正あるいは有害なプログラム、スクリプト等を送信し、書き込み又は他者が受信可能な状態におく行為、本サービスによりアクセス可能な情報を改ざん及び消去する行為、不当に情報やデータを収集する行為並びにこれに至らない全ての不正アクセス行為。</span><br />
            <span>（１３）個人的なクレーム又はトラブルに関する投稿及び本サービスの趣旨に関連のない情報の投稿。</span><br />
            <span>（１４）前各号のほか、本サービス、当サイトの運営その他のプラットフォームの運営を妨げ、又はプラットフォームの信用を毀損する投稿及び行為、本規約に違反する行為、その他のプラットフォームが不適切と判断する投稿及び行為。</span><br />
            <br />
            <span>２．プラットフォームは、ユーザーが、前項各号のいずれかに該当する投稿や行為を行ったと判断した場合又は本規約の内容若しくは趣旨に違反し、若しくは本規約の内容に照らして不適切な行為を行ったと判断した場合には、当該ユーザーに事前に通知することなく、プラットフォームの裁量で登録情報若しくは投稿情報の変更若しくは削除、本サービスを介してコンタクトした相手に対する注意喚起その他の連絡、又は当該ユーザーが会員のときには会員登録の取消を含めたしかるべき措置をとります。また、プラットフォームが定める所定の手続きを経て、当該ユーザーを（特に悪質と判断される場合には悪質不正利用者として）公開する場合があります。なお、プラットフォームは、本項に定める措置を講じたことにより、ユーザー又は第三者に不利益又は損害が発生しても、一切責任を負いません。</span><br />
            <br />
            <span>３．第１項各号の内容は、本規約改定により適宜追加修正される場合があるものとし、ユーザーは、本サービス及び当サイトの利用に当たり常に最新の内容を確認するものとします。</span><br />
            <br />
            <span class="ruleTitle">第８条（反社会的勢力の排除）</span><br />
            <span>プラットフォームは、別に定める「反社会的勢力排除に関する誓約」に基づき、反社会的勢力との関係を遮断しており、ユーザー又は会員が現在若しくは過去に反社会的勢力であり、若しくは反社会的勢力を利用したことがあることが判明した場合又は暴力的な要求行為等をした場合（第三者を利用してする場合を含みます。）は、会員登録を拒否し、若しくは取り消し、又は本サービス及び当サイトの利用を拒み、すでに会員情報や投稿が掲載等されている時にはそれを削除できるものとします。</span><br />
            <br />
            <span class="ruleTitle">第９条（投稿情報の保存と保証）</span><br />
            <span>１．プラットフォームは、会員が本サービスの利用に当たり投稿した情報を確実に記録又は保存することを保証するものではありません。それらの情報の全部又は一部が消失又は変容してもその原因にかかわらずプラットフォームは一切責任を負わず、それらの情報の全部又は一部がプラットフォームの意図するところではなく流出しても、プラットフォームに重大な過失がない限りプラットフォームは一切責任を負いません。また、プラットフォームは、投稿された内容についてプラットフォーム自身の裁量により消去又は破棄する場合があります。</span><br />
            <br />
            <span>２．会員は、情報を投稿する際に、自身で当該情報をバックアップ保存するなどして当該情報の消失に備えるものとします。</span><br />
            <br />
            <span class="ruleTitle">第１０条（商標の無断転用・転載の禁止）</span><br />
            <span>本サービスにおいて、プラットフォームが使用する全ての商標は、プラットフォームにおける商標若しくは登録商標又は権利者から許諾を得た商標若しくは登録商標でありこれらを無断で転用・転載することを禁止します。</span><br />
            <br />
            <span class="ruleTitle">第１１条（連絡又は通知について）</span><br />
            <span>１．ユーザーがプラットフォームに連絡する場合は、プラットフォーム所定の窓口宛に電子メール又は電話にて行うものとし、来訪による連絡は受け付けません。</span><br />
            <br />
            <span>２．プラットフォームがユーザーに連絡する場合は、当サイトへの掲示又は提供されているメールアドレスに対する電子メールによる通知その他のプラットフォームが適切と判断する方法により行います。</span><br />
            <br />
            <span class="ruleTitle">第１２条（個人情報の利用）</span><br />
            <span>１．プラットフォームは、ユーザーから取得する氏名、所属、メールアドレス、電話番号等、特定の個人を識別することができる情報（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含みます。以下「個人情報」といいます。）については、特に定めのない限り個人情報関連法令に加え別に定める<a
                href="https://future-city.go.jp/sdgs/policy.html"
                target="_blank">「プライバシーポリシー」</a>の規定に従って取り扱います。</span><br />
            <br />
            <span>２．本サービスに含まれる一部のサービスにおいては、個人を特定できない形でプラットフォームのサービスの利用に関する事項が公開される場合があります。</span><br />
            <br />
            <span>３．プラットフォームは、本サービスを提供するために必要な作業を第三者に委託することがありますが、その場合にはユーザー情報の一部又は全部を当該第三者に提供できるものとします。提供するに当たっては、個人情報関連法令に加えプライバシーポリシー等の定めるところにより個人情報の保護が適切に図られるように措置するものとします。</span><br />
            <br />
            <span class="ruleTitle">第１３条（会員の入会）</span><br />
            <span>１．本サービスのうち、会員専用のサービス（以下、「会員サービス」という。）を利用するためには、会員として入会いただき、ログインするためのログインＩＤ及びパスワードの設定が必要です。</span><br />
            <br />
            <span>２．会員として入会できるのは、<a
              href="https://future-city.go.jp/data/pdf/platform/platform1.pdf"
              target="_blank">「地方創生ＳＤＧｓ官民連携プラットフォーム規約」</a>に掲げる会員の条件を満たす者とし、同規約を遵守するものとします。</span><br />
            <br />
            <span>３．会員として入会を希望する場合は、プラットフォームが定める方法で会員として必要な真実かつ正確な最新の情報を提供し、入会を申請するものとします。</span><br />
            <br />
            <span>４．プラットフォームは、受領した会員として必要な情報の内容を審査し、入会申請を承認又は拒否します。</span><br />
            <br />
            <span>５．プラットフォームは、入会の申込を拒否し又は承認しない場合、当該申込者に対し拒否し又は承認しない理由を開示又は説明する義務を負わず、拒否し又は承認しないことによって申込者に生じる損害又は不利益については一切責任を負いません。</span><br />
            <br />
            <span class="ruleTitle">第１４条（会員の登録情報）</span><br />
            <span>１．会員は、自らの登録情報の内容が真実かつ正確な最新の情報であるように必要に応じて更新を行うものとします。会員の登録情報は、入会時の申請情報、団体プロフィールの情報、会員サービスの利用に関する情報等を含みます。</span><br />
            <br />
            <span>２．前項に違反し、真実かつ正確な最新のデータが提供されていないとプラットフォームが判断した場合には、プラットフォームは、当該会員のログインＩＤを削除し会員登録を取り消し又は一時的に停止するほか、将来にわたって本サービスの利用をお断りすることがあります。</span><br />
            <br />
            <span>３．会員は、ログインＩＤ及びパスワードを他人に推知されないよう自己の責任で管理するものとします。</span><br />
            <br />
            <span>４．会員は、ログインＩＤ及びパスワードの情報が第三者に漏洩した場合又はその恐れがある場合には、速やかにプラットフォームが定める連絡先まで連絡するものとします。この場合、プラットフォームは、事前の通知なく当該ログインＩＤ及びパスワードによる本サービスの利用を停止し、又は終了させることができるものとします（会員登録の取消又は一時停止を含みます。）。</span><br />
            <br />
            <span>５．会員は、ログインＩＤを譲渡、売買、貸与、その他の形態を問わずいかなる処分もすることはできません。また、本規約に基づく権利及び義務の全部又は一部を第三者に移転し使用させ第三者の担保に供してはなりません。</span><br />
            <br />
            <span>６．ログインＩＤ及びパスワードを利用して行われたあらゆる行為は、第三者が会員本人の同意なく行った場合や不正に使用した場合であっても当該ログインＩＤの登録されている会員自身による行為とみなすものとし、会員はその一切の責任を負うことに同意するものとします。</span><br />
            <br />
            <span>７．会員が登録した情報は、会員自らがその内容について責任を負うものとし当サイト上で掲載、他人に開示、提供又は送付する会員の登録情報に基づいて構成されるコンテンツ（情報、デ－タ、文書、ソフトウェア、音楽、写真、映像、ビデオ、メッセージ、文字等をいいます。以下同じ。）に関する責任についてプラットフォームが会員に代わり責任を負うこと及びコンテンツの内容を管理することはありません。</span><br />
            <br />
            <span>８．会員が登録した最終の住所やメールアドレス等にプラットフォームから送付した通知は、開封の有無にかかわらず、また、第１項の更新がなされなかったこと等の原因で不達の場合にかかわらず、通常到達するために要する期間を経過した時に会員に到達したものとみなします。</span><br />
            <br />
            <span class="ruleTitle">第１５条（会員サービス）</span><br />
            <span>１．会員が利用できるサービス・機能は、次の各号に掲げるものとします。</span><br />
            <span>なお、各種サービス・機能の利用に関わる具体的な内容及び手続き等については「地方創生ＳＤＧｓ官民連携プラットフォーム会員活動の手引き」及び「地方創生ＳＤＧｓ官民連携プラットフォーム分科会運営の手引き」に定める。</span><br />
            <span>（１）会員プロフィールの登録及び掲載</span><br />
            <span>　　　会員プロフィール、重点取組など、基本情報の登録及び掲載が可能です。</span><br />
            <span>（２）自団体へのメンバー追加</span><br />
            <span>　　　会員である団体は任意にメンバーを追加可能です。</span><br />
            <span>（３）課題の登録及び掲載</span><br />
            <span>　　　課題の解決・ＳＤＧｓの達成に向けた提案を募るため、会員は自団体が抱えている課題内容の登録及び掲載が可能です（以下、課題の登録を行った会員を「課題登録者」といいます）。</span><br />
            <span>（４）ソリューションの登録及び掲載</span><br />
            <span>　　　課題の解決・ＳＤＧｓの達成に貢献できるソリューションの登録及び掲載が可能です。</span><br />
            <span>（５）登録した課題又はソリューションに関連する情報の閲覧</span><br />
            <span>　　　課題又はソリューションを登録した会員は、マイページ上で登録した課題又はソリューションに関連するカテゴリの連携事例・課題・ソリューションの閲覧が可能です。</span><br />
            <span>（６）公開掲示板の閲覧及び投稿</span><br />
            <span>　　　掲載されている課題やソリューションについて、公開掲示板を用いて、その課題やソリューションの登録団体とコミュニケーションをとることが可能です。また、他のユーザーの投稿を閲覧することが可能です。</span><br />
            <span>（７）課題への提案</span><br />
            <span>　　　自団体が所有しているノウハウ等を活用することで解決の可能性がある課題に対し、提案を登録することができます（以下、提案の登録を行ったユーザーを「提案登録者」といいます。）。ただし、プラットフォームが、提案内容について課題に即していないと判断した場合、又は、単なる商品又はサービスの営業活動と判断した場合、その提案を非承認とすることがあります。</span><br />
            <span>（８）ソリューションの登録団体への提案依頼</span><br />
            <span>　　　課題登録者は、自団体の課題の解決手段として有効であることが期待できるソリューションについて、そのソリューションの登録団体へ提案を依頼することが可能です。</span><br />
            <span>（９）非公開掲示板の活用</span><br />
            <span>　　　提案を受けた課題登録者は、その提案内容について、非公開掲示板を用いて、提案登録者とコミュニケーションをとることが可能です。</span><br />
            <span>（１０）官民連携事例の登録及び掲載</span><br />
            <span>　　　事例をもとに他のユーザーの官民連携への意欲・関心を高め、取組を促進するため、事業が実現した官民連携の取組を登録し、情報発信することが可能です。</span><br />
            <span>（１１）マッチングイベントへの参加</span><br />
            <span>　　　マッチングイベントにて、登録した課題、ソリューション、提案を用いて、対話型の情報発信及び意見交換することが可能です。</span><br />
            <span>（１２）分科会の活動</span><br />
            <span>　　　分科会の設置、又は分科会への参加/退会、分科会運営メンバー管理/メンバー区分変更や活動報告を行うことが可能です。分科会に関する活動は、「分科会規程」に基づくものとします。また、プラットフォームへ事前申請することで、分科会が主催するイベント告知や分科会に関するお知らせを掲載・発信することが可能です。発信可能な情報及び手続きについては、「地方創生ＳＤＧｓ官民連携プラットフォーム分科会運営の手引き」に定めます。</span><br />
            <span>（１３）会員専用問い合わせフォームの利用</span><br />
            <span>　　　会員は、一般的な問い合わせ窓口に加え、マイページ内「ユーザーメニュー」の問い合わせフォームが利用可能です。</span><br />
            <span>（１４）会員主催イベント・お知らせの情報発信</span><br />
            <span>　　　プラットフォームへ事前申請することで、会員が主催するイベントの告知や会員活動に関するお知らせを掲載・発信することが可能です。発信可能な情報及び手続きについては、「地方創生ＳＤＧｓ官民連携プラットフォーム会員活動の手引き」に定めます。</span><br />
            <span>（１５）後援等名義使用の申請</span><br />
            <span>　　　プラットフォームへ事前申請し、承認を受けることで、会員が主催又は共催する講演会・講習会等のイベントについて、プラットフォームの後援等名義を使用することが可能です。申請内容の審査基準は「地方創生ＳＤＧｓ官民連携プラットフォームの後援等名義に関する規程」に定めます。</span><br />
            <span>（１６）ロゴマークのダウンロード</span><br />
            <span>　　　プラットフォームの活動をさらに推進し、会員活動を地域及び国内外にＰＲするためのツールとして、プラットフォームのロゴマークを活用することが可能です。ロゴマークの活用にあたっては、別途定める「地方創生ＳＤＧｓ官民連携プラットフォームロゴマーク使用規約」及び「地方創生ＳＤＧｓ官民連携プラットフォームロゴマーク使用ガイドライン」を遵守するものとします。</span><br />
            <span>（１７）メールマガジンによるプラットフォーム活動等の情報受信等</span><br />
            <span>　　　プラットフォーム、分科会又は会員が、主催又は共催するイベント等のお知らせ、プラットフォームに新規登録された課題・ソリューションの紹介など、プラットフォームからのメールマガジンによる案内を受信できます。</span><br />
            <span>（１８）伴走支援窓口の利用・開設（新規伴走支援事業者はR6年度募集開始予定）</span><br />
            <span>　　　会員は、地域課題解決にむけて、地方公共団体等への支援実績がある事業者（以下、「伴走支援事業者」といいます。）に対し、伴走支援窓口を通じて相談や支援依頼をすることができます。</span><br />
            <span>　　　なお、支援内容や料金体系などは伴走支援事業者ごとに異なりますので、各事業者との個別具体的なやりとりを開始する際は、前もってご確認ください。（確認不足などによる金銭関係等のトラブル発生時にプラットフォームは責任を負いかねます。）</span><br />
            <span>　　　また、地方公共団体等の地域課題解決に関する支援実績のある民間団体等の会員は、プラットフォームに申請し、承認を受けることで、伴走支援事業者として窓口の開設や各種情報掲載をすることができます。申請に必要な資料や要項等の詳細はマイページ内「資料一覧」の「伴走支援窓口開設について」（新規伴走支援事業者募集開始時に掲載予定）を参照してください。</span><br />
            <br />
            <span>２．プラットフォームは、第１項各号のサービスを効果的に提供するため、会員の同意を得て掲載・投稿内容の一部を加工することがあります。</span><br />
            <br />
            <span class="ruleTitle">第１６条（会員の除名又は退会）</span><br />
            <span>１．プラットフォームは、会員が<a
              href="https://future-city.go.jp/data/pdf/platform/platform1.pdf"
              target="_blank">「地方創生ＳＤＧｓ官民連携プラットフォーム規約」</a>に定める会員の除名条件に該当する場合、又は、会員が次の各号のいずれかに該当する場合には、会員を除名し、若しくは一時的に停止し、会員の権利を取り消し、又は将来にわたって本サービスのご利用をお断りする場合があります。</span><br />
            <span>（１）会員登録内容又は会員サービス利用時の投稿内容の全部又は一部に、不正確、不実、若しくは虚偽の、又は誤認を生じさせる内容が含まれていた場合。</span><br />
            <span>（２）本規約に定める禁止行為を過去に行っている、若しくは過去に行い又は将来行う恐れがあると認められる場合。</span><br />
            <span>（３）倒産等の理由により会員サービスの継続的な利用が困難であるとプラットフォームが判断した場合。</span><br />
            <span>（４）その他、法令又は本規約の内容若しくは趣旨に違反した行為、又は本規約の内容に照らして不適切な行為を行ったとプラットフォームが判断した場合。</span><br />
            <br />
            <span>２．会員は<a
              href="https://future-city.go.jp/data/pdf/platform/platform1.pdf"
              target="_blank">「地方創生ＳＤＧｓ官民連携プラットフォーム規約」</a>によって定める所定の手続きにより退会することができます。プラットフォームからの退会は「団体」としての退会となり、団体に登録されている全てのユーザーが退会となります。</span><br />
            <br />
            <span>３．第１項により除名された会員又は前項により退会した会員は、会員サービスの提供中止、及び利用に関する一切の権利を失うものとし、プラットフォームは、<a
              href="https://future-city.go.jp/data/pdf/platform/platform1.pdf"
              target="_blank">「地方創生ＳＤＧｓ官民連携プラットフォーム規約」</a>に定める会員の退会・除名条件に該当する場合において運用上可能かつ合理的な期間内に会員サービスの提供を中止します。</span><br />
            <br />
            <span>４．前項の措置により会員又は第三者に生ずる一切の損害について、直接的か間接的かを問わず、プラットフォームは、一切責任を負わないものとします。ただし、会員としての本サービスの利用により生じた責任及び義務については、除名又は退会後も有効であるものとします。</span><br />
            <br />
            <span class="ruleTitle">第１７条（免責事項）</span><br />
            <span>１．プラットフォームは、本サービスによって、又は当サイトにおいて提供する情報（以下「提供情報」といいます。）について、会員による投稿に基づくものであるか否かにかかわらず、いかなる表明又は保証（明示的、黙示的を問いません。）も行うものではなく、とりわけ、これらの内容、品質、正確性、適法性（知的財産権その他の他人の権利を侵害していないことを含みます。）、有用性、信憑性、速報性及び完全性については、確認しておらず、確認の義務を負わず、いかなる表明又は保証（明示的、黙示的を問いません。）も行うものではありません。</span><br />
            <br />
            <span>２．プラットフォームは、本サービス又は当サイトを介し会員に対してアドバイスを行うことはありますが、これらのアドバイスの正確性若しくは有用性又はユーザーの望む結果の実現に対して一切責任を負いません。</span><br />
            <br />
            <span>３．プラットフォームは、ユーザー間による意見交換、連携、商談、交渉、取引又は契約について当事者となるものではなく一切責任を負いません。本サービス及び当サイトをきっかけとするユーザー間又はユーザーと第三者との間に生じた紛争（知的財産権侵害に起因するものを含みます。）について、プラットフォームは一切責任を負わず、当該紛争については訴訟内外を問わず当事者間で解決するものとします。</span><br />
            <br />
            <span>４．プラットフォームは、第３条第１項の規定に基づき本サービスを変更、停止又は廃止したことにより、ユーザー又は第三者に不利益又は損害が発生したとしても、一切責任を負いません。</span><br />
            <br />
            <span>５．プラットフォームは、ログインＩＤ及びパスワードの盗用、紛失又は第三者による不正使用により会員又は第三者に不利益又は損害が発生したとしても、会員の故意又は過失の有無を問わず、一切責任を負いません。</span><br />
            <br />
            <span>６．プラットフォームは、第４条各号の事由、通信回線の不具合その他の原因による本サービス若しくは当サイトの中断又は当サイトへの接続不良により、ユーザー又は第三者に不利益又は損害が発生したとしても、一切責任を負いません。</span><br />
            <br />
            <span>７．当サイトよりリンクされているウェブサイト及び当サイト上に掲載されている情報からリンクされているウェブサイトは、各ウェブサイトの管理者の責任により運営されています。プラットフォームは、これらのウェブサイトについて関知するものではなく、違法なものでないこと、内容が正確であること、不快な内容を含まないものであること、利用者が意図していない情報を含まないものであること等を一切保証いたしません。</span><br />
            <br />
            <span>８．当サイトに会員が投稿し掲載された情報について第三者が第６条に違反して、譲渡、編集、使用、複製、転載、転送等を行うこと、その他の正当な権利者の権利を侵害したことによりユーザーに損害が生じてもプラットフォームは一切責任を負いません。</span><br />
            <br />
            <span>９．プラットフォームは、当サイト及びそのコンテンツとリンクを、現状有姿で提供し、ユーザーは、自身の責任において利用するものとします。本サービス提供の状態、アクセスの可能性及び使用の状態並びに本サービス及び当サイトのシステム（そのコンテンツ、ハードウェア、ソフトウェア及びリンクを含みます。）に関し、特定目的適合性、商品性、権限、非侵害性、結果、正確性、完全性、アクセス可能性、互換性、セキュリティ、コンピューターウイルスに感染していないこと等について、明示的にも、黙示的にも、保証するものではなく、それにより発生したコンピューター、回線、ソフトウェア等の損害について一切責任を負いません。</span><br />
            <br />
            <span>１０．前各項のほか、提供情報の使用及びそれに依拠した意見交換、連携、商談、交渉、取引又は契約、提供情報の使用不能、本規約に基づいてプラットフォームが取った措置、ユーザーによる本規約に違反する行為、その他の本規約に照らして不適切な行為（故意・過失の有無を問いません。）等により、ユーザー又は第三者に不利益又は損害が発生した場合にもプラットフォームは一切責任を負いません。プラットフォームの責任は、本規約の条項に記載の範囲に限られます。なお、ユーザーによる本規約違反に起因又は関連して生じた全てのクレームや請求への対応に関連してプラットフォームに費用が発生した場合又はプラットフォームが賠償金等の支払いを行った場合には、ユーザーは当該費用及び賠償金等（プラットフォームが支払った弁護士費用を含みます。）の一切を負担するものとします。</span><br />
            <br />
            <span class="ruleTitle">第１８条（機密の保持）</span><br />
            <span>１．ユーザーは、当サイトをきっかけとした全てのユーザー間連携又はその過程において、取引の相手方たるユーザーから機密である旨示されて開示される機密情報、取引遂行中に知り得た機密情報及び取引の相手方が保持する個人情報を全て機密として保持し、当該相手方との取引の目的以外には一切使用せず、第三者に開示又は漏えいしないものとします。</span><br />
            <br />
            <span>２．前項の規定にかかわらず、機密情報又は個人情報を他のユーザーから取得したユーザー（以下「機密情報等受領ユーザー」といいます。）が、次のいずれかに該当することを証明したものについては、機密情報から除かれるものとします。ただし、個人情報については（６）のみが適用されるものとします。</span><br />
            <span>（１）既に公知、公用の情報</span><br />
            <span>（２）開示を受けた時点で既に知得していた情報</span><br />
            <span>（３）開示を受けた後に機密情報等受領ユーザーの責によらず公知、公用となった情報</span><br />
            <span>（４）開示を受けた後に正当な権限を有する第三者から守秘義務を負うことなしに適法に入手した情報</span><br />
            <span>（５）開示者が、第三者に開示することを文書により承諾した情報</span><br />
            <span>（６）法令又は確定判決等により開示を義務付けられた情報</span><br />
            <br />
            <span>３．機密情報等受領ユーザーが、機密情報を利用するに当たっては、開示目的を達成するために最小限必要な者に限定して開示するものとします。この場合、機密情報等受領ユーザーは、機密情報を開示した者が機密情報を漏えいし、又は開示目的以外に利用しないよう、監督その他の必要な措置を講ずる義務を負います。</span><br />
            <br />
            <span>４．機密情報等受領ユーザーは、機密情報を極秘にして取り扱い、そのために合理的な安全管理体制及び漏えい防止手段を講じる義務を負うものとします。</span><br />
            <br />
            <span>５．ユーザーは、ユーザー間連携又は交渉を開始する前に必要に応じ別途機密保持契約を締結し相互の機密保持に努めるものとします。また、ユーザーは、当該機密保持契約の締結の有無にかかわらず、ユーザー間連携及び交渉に関し相互に本条に定める機密保持義務を負うものとし、プラットフォームがユーザーによるそれらの機密保持義務の履行を保証するものではなく、ユーザーによる秘密保持義務違反についてプラットフォームは一切責任を負わないものとします。</span><br />
            <br />
            <span class="ruleTitle">第１９条（本規約の効力）</span><br />
            <span>１．本規約は令和４年３月４日から発効するものとし改定後の規約は改定前の規約に優先して適用されるものとします。ただし、改定前に行われた行為、処分等に係る義務、責任等は、改定前の規約によるものとします。</span><br />
            <br />
            <span>２．管轄司法機関等によって本規約の条項の一部が無効若しくは強制力がない、又は合意の内容となっていないと判断された場合においても、その判断は当該条項以外に及ぶものではなく、また、本規約の他の条項はその完全な効力を維持するものとします。かかる場合において、無効若しくは強制力がない、又は合意の内容となっていないと判断された条項は、当該条項により達成しようとしていた内容に経済的に最も近い内容で、かつ、適用法により合意の内容として有効である内容に自動的に変更されるものとします。</span><br />
            <br />
            <span>３．本規約上のユーザーの義務は、本サービス、当サイト、ユーザーの本サービス利用又は本規約の終了によっても、既に発生している義務は消滅せず継続するものとします。</span><br />
            <br />
            <span class="ruleTitle">第２０条（準拠法）</span><br />
            <span>本規約は、日本法に準拠し同法に従って解釈されるものとし、本規約並びに本サービス及び当サイトの使用に起因又は関連するすべての紛争（契約、不法行為、その他の法的責任を追及するものを含みますが、これらに限られません。）は、日本法に準拠して解決するものとします。</span><br />
            <br />
            <span class="ruleTitle">第２１条（専属管轄）</span><br />
            <span>本規約に起因し又は関連して紛争が生じたときは、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</span><br />
            <br />
            <span>（制定）令和4年3月4日</span><br />
            <span>（改定）令和5年1月20日</span><br />

            <div class="ruleMargin"></div>
          </p-accordionTab>
        </p-accordion>

        <!-- 規約チェック -->
        <div class="p-d-flex p-jc-center ruleCheck">
          <div class="p-as-center">
            <i class="pi pi-exclamation-circle platform-warning-text">
              上記の利用規約を確認するとチェックできるようになります。
            </i>
            <br />
            <div class="p-d-flex p-jc-center">
              <p-checkbox [value]="true" label="上記規約に同意する" [disabled]="!ruleCheck" [(ngModel)]="ruleCheckFlag">
              </p-checkbox>
              <div class="p-as-center">
                <span class="required">【必須】</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 入力フォーム -->
      <form [formGroup]="a201ApplicationInputForm">
        <!-- 申請情報 -->
        <div class="application-information">
          <!-- 申請備考 -->
          <div class="application-note">
            <label>
              会員情報登録にご記載いただく「団体名」や「ウェブサイトＵＲL」等は、本プラットフォームＨＰの会員情報欄に掲載します。<br />
            </label>
            <!-- 公開 -->
            <p-tag value="公開" styleClass="public-tag"></p-tag>
            …本プラットフォームＨＰに掲載する情報です。<br />
            <!-- 非公開 -->
            <p-tag value="非公開" styleClass="private-tag"></p-tag>
            …本プラットフォームＨＰに掲載しない情報です。
          </div>

          <!-- 申請内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- 会員種別 -->
              <tr>
                <td class="item-input-name">
                  会員種別
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-dropdown [options]="getDicList(1)" optionLabel="sp_name" optionValue="sp_code"
                    placeholder="選択してください" [showClear]="true" styleClass="information-Form-dropdown"
                    formControlName="class_id"></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('class_id')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 団体名称 -->
              <tr>
                <td class="item-input-name">
                  団体名称
                  <span class="required">【必須】</span>
                  <span class="warning-number">（全角）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText placeholder="例）内閣府" class="information-Form-inputtext-wMax"
                    formControlName="organization_name" />
                  <span>※地方公共団体の場合は都道府県からご入力ください。</span>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="
                      a201ApplicationInputForm.get('organization_name')
                    ">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 団体名称フリガナ -->
              <tr>
                <td class="item-input-name">
                  団体名称フリガナ
                  <span class="required">【必須】</span>
                  <span class="warning-number">（半角ｶﾅ）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText placeholder="例）ﾅｲｶｸﾌ" class="information-Form-inputtext-wMax"
                    formControlName="organization_kana" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="
                      a201ApplicationInputForm.get('organization_kana')
                    ">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 法人番号 -->
              <tr>
                <td class="item-input-name">
                  法人番号(13裄)
                  <span class="required">【必須】</span>
                  <span class="warning-number">（半角数字）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  法人番号は<a href="https://www.houjin-bangou.nta.go.jp/" target="_blank">こちら</a>からご確認できます。
                  <div class="w4">
                    <input type="text" pInputText placeholder="例）1234567890123" class="information-Form-inputtext-wMax"
                      formControlName="organization_no" />
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('organization_no')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 郵便番号 -->
              <tr>
                <td class="item-input-name">
                  郵便番号
                  <span class="required">【必須】</span>
                  <span class="warning-number">（半角数字）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="p-d-flex">
                    <input type="text" pInputText placeholder="例）1008968" formControlName="postal_no" />
                    <button pButton type="button" label="郵便番号検索" class="button1 postal_no_button"
                      (click)="openPostalNoDialog()"></button>
                  </div>

                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('postal_no')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 都道府県 -->
              <tr>
                <td class="item-input-name">
                  都道府県
                  <span class="required">【必須】</span>
                  <span class="warning-number">（全角）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="w5">
                    <input type="text" pInputText placeholder="例）東京都" class="information-Form-inputtext-wMax"
                      formControlName="prefectures" />
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('prefectures')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 所在地（市区町村） -->
              <tr>
                <td class="item-input-name">
                  所在地（市区町村）
                  <span class="required">【必須】</span>
                  <span class="warning-number">（全角）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="w6">
                    <input type="text" pInputText placeholder="例）千代田区" class="information-Form-inputtext-wMax"
                      formControlName="city" />
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('city')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 所在地（町域） -->
              <tr>
                <td class="item-input-name">
                  所在地（町域）
                  <span class="required">【必須】</span>
                  <span class="warning-number">（全角）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="w7">
                    <input type="text" pInputText placeholder="例）永田町" class="information-Form-inputtext-wMax"
                      formControlName="town_area" />
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('town_area')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 所在地（番地・建物 -->
              <tr>
                <td class="item-input-name">
                  所在地（番地・建物）
                  <span class="required">【必須】</span>
                  <span class="warning-number">（全角）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="w8">
                    <input type="text" pInputText placeholder="例）１－１１－３９　永田町合同庁舎８F"
                      class="information-Form-inputtext-wMax" formControlName="address_building" />
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('address_building')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 業種 -->
              <tr>
                <td class="item-input-name">
                  業種
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <p-dropdown [options]="industryIdCodeList" optionLabel="sp_name" optionValue="sp_code"
                    placeholder="選択してください" [showClear]="true" styleClass="information-Form-dropdown"
                    formControlName="industry_id"></p-dropdown>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('industry_id')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 団体ウェブサイトURL -->
              <tr>
                <td class="item-input-name">ウェブサイトURL</td>
                <td class="item-label-name">
                  <p-tag value="公開" styleClass="public-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText placeholder="例）https://future-city.go.jp/platform/"
                    class="information-Form-inputtext-wMax" formControlName="url" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('url')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 部局名 -->
              <tr>
                <td class="item-input-name">
                  部局名
                  <span class="warning-number">（全角）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText placeholder="例）環境経済部" class="information-Form-inputtext-wMax"
                    formControlName="department_name" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('department_name')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 課室名 -->
              <tr>
                <td class="item-input-name">
                  課室名
                  <span class="warning-number">（全角）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText placeholder="例）環境政策課" class="information-Form-inputtext-wMax"
                    formControlName="division_name" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('division_name')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 役職 -->
              <tr>
                <td class="item-input-name">
                  役職
                  <span class="warning-number">（全角）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <input type="text" pInputText placeholder="例）局長" class="information-Form-inputtext-wMax"
                    formControlName="jobposition_name" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('jobposition_name')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 氏名 -->
              <tr>
                <td class="item-input-name">
                  氏名
                  <span class="required">【必須】</span>
                  <span class="warning-number">（全角）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information input-name">
                  <!-- <label class="information-Form-input-note"
                    >全角で入力してください。</label
                  >
                  <br /> -->
                  <input type="text" pInputText placeholder="例）内閣府　太郎" class="information-Form-inputtext-wMax"
                    formControlName="full_name" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('full_name')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 電話番号 -->
              <tr>
                <td class="item-input-name">
                  電話番号
                  <span class="required">【必須】</span>
                  <span class="warning-number">（半角数字、ハイフン不要）</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information input-phone">
                  <!-- <label class="information-Form-input-note"
                    >半角数字で入力してください。</label
                  >
                  <br /> -->
                  <input type="text" pInputText placeholder="例）0123456789" class="information-Form-inputtext-wMax"
                    formControlName="tel" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('tel')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- eメールアドレス -->
              <tr>
                <td class="item-input-name">
                  eメールアドレス
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    <label>
                      正しくメールアドレスをご入力してください。誤入力の場合、運営事務局からのメールが受信できません。（重複申請不可）
                    </label>
                  </div>
                  <input type="text" pInputText placeholder="例）abcdeg0123@hijklmn.jp"
                    class="information-Form-inputtext-wMax" formControlName="email" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('email')">
                  </app-validator-message>
                </td>
              </tr>
              <!-- eメールアドレス確認登録 -->
              <tr>
                <td class="item-input-name">
                  eメールアドレス確認
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <div class="warning-text">
                    <label> 確認のため、もう一度ご入力ください。 </label>
                  </div>
                  <input type="text" pInputText placeholder="例）abcdeg0123@hijklmn.jp"
                    (input)="checkConfirmationEmail(true)" class="information-Form-inputtext-wMax"
                    formControlName="email_confirmation" />
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="
                      a201ApplicationInputForm.get('email_confirmation')
                    ">
                  </app-validator-message>
                </td>
              </tr>
              <!-- 2020プラットフォーム誓約書 -->
              <tr>
                <td class="item-input-name">
                  プラットフォーム誓約書<br />
                  <span class="required">【必須】</span>
                </td>
                <td class="item-label-name">
                  <p-tag value="非公開" styleClass="private-tag"></p-tag>
                </td>
                <td class="item-information">
                  <a href="https://future-city.go.jp/sdgs/platform_kiyaku.html"
                    target="_blank">利用規約
                    <i class="pi pi-clone"></i>
                  </a>
                  に同意の上、こちらの
                  <a href="https://naikakufu-prod-etc.s3.ap-northeast-1.amazonaws.com/%E8%AA%93%E7%B4%84%E6%9B%B8.pdf"
                    target="_blank">
                    誓約書
                    <i class="pi pi-clone"></i> </a>に代表者捺印したものをスキャンしたＰＤＦファイルを添付してください。<br />
                  ファイル容量は10MBまでです。<br />
                  ファイルがアップロードできない場合、<a href="https://future-city.go.jp/platform/inquire/"
                    target="_blank">運営事務局</a>へお問い合わせください。<br />
                  ※郵送は受け付けておりません。<br />
                  <p-fileUpload #fileUpload [chooseLabel]="'ファイルを選択'" [cancelLabel]="'キャンセル'" [showUploadButton]="false"
                    fileLimit="1" (onSelect)="uploadFile($event, fileUpload)" (onRemove)="deleteFile()"
                    (onClear)="deleteFile()">
                    <ng-template pTemplate="content">
                      <div class="p-fileupload-files ng-star-inserted" *ngIf="pledge">
                        <div class="ng-star-inserted">
                          <div class="p-fileupload-row ng-star-inserted">
                            <div>{{fileName}}</div>
                            <div></div>
                            <div>
                              <button type="button" icon="pi pi-times" pbutton="" ng-reflect-icon="pi pi-times"
                                class="p-button p-component p-button-icon-only" (click)="deleteFile()">
                                <span class="p-button-icon pi pi-times" aria-hidden="true"></span>
                                <span aria-hidden="true" class="p-button-label">&nbsp;</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </p-fileUpload>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div class="information-margin"></div>

        <!-- アンケート情報 -->
        <div class="a201-question-information">
          <!-- アンケートタイトル -->
          <div class="question-title">
            <h1>入会時アンケート</h1>
          </div>

          <!-- アンケート備考 -->
          <div>
            <label>
              以下の入会時アンケートの回答にご協力ください。ご記載いただいた内容は、今後の運営の参考にさせていただきます。<br />
              ※回答結果は公表いたしません。
            </label>
          </div>

          <div class="question-margin"></div>

          <!-- アンケート小タイトル -->
          <h2>加入申込について</h2>
          <!-- アンケート内容1 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- （1）本プラットフォームを知った・・・ -->
              <tr>
                <td class="item-updown-input-name">
                  <div class="p-d-flex">
                    （1）
                    <div>
                      本プラットフォームを知った、または加入を希望したきっかけは何ですか。
                    </div>
                  </div>
                  <div class="input-name-note">※複数選択可。</div>
                </td>
              </tr>
              <tr>
                <td class="item-updown-information">
                  <div *ngFor="let dicData of getDicList(801)">
                    <p-checkbox [label]="dicData.sp_order + '.' + dicData.sp_name" [value]="dicData.sp_code"
                      [formControl]="
                        a201ApplicationInputForm.controls['questionary1']
                      "></p-checkbox>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('questionary1')">
                  </app-validator-message>
                  <br />
                  <div class="information-Form-inputtext-wMaxarea">
                    <textarea pInputTextarea formControlName="questionary1_other"></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="
                        a201ApplicationInputForm.get('questionary1_other')
                      ">
                    </app-validator-message>
                  </div>
                </td>
              </tr>
              <!-- （2）本プラットフォームへの加入を希望する・・・ -->
              <tr>
                <td class="item-updown-input-name">
                  <div class="p-d-flex">
                    （2）
                    <div>
                      本プラットフォームへの加入を希望する理由および本プラットフォームに期待することは何ですか。
                    </div>
                  </div>
                  <div class="input-name-note">※複数選択可。</div>
                </td>
              </tr>
              <tr>
                <td class="item-updown-information">
                  <div *ngFor="let dicData of getDicList(802)">
                    <p-checkbox [label]="dicData.sp_order + '.' + dicData.sp_name" [value]="dicData.sp_code"
                      [formControl]="
                        a201ApplicationInputForm.controls['questionary2']
                      "></p-checkbox>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('questionary2')">
                  </app-validator-message>
                  <br />
                  <div class="information-Form-inputtext-wMaxarea">
                    <textarea pInputTextarea formControlName="questionary2_other"></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="
                        a201ApplicationInputForm.get('questionary2_other')
                      ">
                    </app-validator-message>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="question-margin"></div>

          <!-- アンケート小タイトル -->
          <h2>官民連携マッチングについて</h2>
          <!-- アンケート内容2 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- （3）本プラットフォームでは地方公共団体が抱える課題に対し・・・ -->
              <tr>
                <td class="item-updown-input-name">
                  <div class="p-d-flex">
                    （3）
                    <div>
                      本プラットフォームでは地方公共団体が抱える課題に対し、協働で考え取り組む民間団体等と連携することを目的としたマッチング支援を実施しています。<br />
                      マッチングについて、どのような方法を希望しますか。
                    </div>
                  </div>
                  <div class="input-name-note">※複数選択可。</div>
                </td>
              </tr>
              <tr>
                <td class="item-updown-information">
                  <div *ngFor="let dicData of getDicList(803)">
                    <p-checkbox [label]="dicData.sp_order + '.' + dicData.sp_name" [value]="dicData.sp_code"
                      [formControl]="
                        a201ApplicationInputForm.controls['questionary3']
                      "></p-checkbox>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('questionary3')">
                  </app-validator-message>
                  <br />
                  <div class="information-Form-inputtext-wMaxarea">
                    <textarea pInputTextarea formControlName="questionary3_other"></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="
                        a201ApplicationInputForm.get('questionary3_other')
                      ">
                    </app-validator-message>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="question-margin"></div>

          <!-- アンケート小タイトル -->
          <h2>他マッチングプラットフォーム・サービスについて</h2>
          <!-- アンケート内容 -->
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- （4）地方創生ＳＤＧｓ官民連携プラットフォーム以外に、・・・ -->
              <tr>
                <td class="item-updown-input-name">
                  <div class="p-d-flex">
                    （4）
                    <div>
                      地方創生SDGs官民連携プラットフォーム以外に、他の官民連携マッチングプラットフォームやサービスに加入・利用していますか。
                    </div>
                  </div>
                  <div class="input-name-note">
                    ※選択肢から1つ選択してください
                  </div>
                </td>
              </tr>
              <tr>
                <td class="item-updown-information">
                  <div *ngFor="let dicData of getDicList(804)">
                    <p-radioButton name="questionary4" [label]="dicData.sp_order + '.' + dicData.sp_name"
                      [value]="dicData.sp_code" formControlName="questionary4"></p-radioButton>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('questionary4')">
                  </app-validator-message>
                  <br />
                  <div class="information-Form-inputtext-wMaxarea">
                    <textarea pInputTextarea formControlName="questionary4_other"></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="
                        a201ApplicationInputForm.get('questionary4_other')
                      ">
                    </app-validator-message>
                  </div>
                </td>
              </tr>
              <!-- （５）上記問（４）にて他プラットフォーム・サービスに加入していると回答した場合・・・ -->
              <tr>
                <td class="item-updown-input-name">
                  <div class="p-d-flex">
                    （5）
                    <div>
                      上記問（4）にて他プラットフォーム・サービスに加入していると回答した場合（選択肢1.又は2.）、加入・利用している理由は何ですか。
                    </div>
                  </div>
                  <div class="input-name-note">※複数選択可</div>
                </td>
              </tr>
              <tr>
                <td class="item-updown-information">
                  <div *ngFor="let dicData of getDicList(805)">
                    <p-checkbox [label]="dicData.sp_order + '.' + dicData.sp_name" [value]="dicData.sp_code"
                      [formControl]="
                        a201ApplicationInputForm.controls['questionary5']
                      "></p-checkbox>
                  </div>
                  <!-- エラーメッセージ出力箇所 -->
                  <app-validator-message [control]="a201ApplicationInputForm.get('questionary5')">
                  </app-validator-message>
                  <br />
                  <div class="information-Form-inputtext-wMaxarea">
                    <textarea pInputTextarea formControlName="questionary6"></textarea>
                    <!-- エラーメッセージ出力箇所 -->
                    <app-validator-message [control]="a201ApplicationInputForm.get('questionary6')">
                    </app-validator-message>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <div class="question-margin"></div>
        </div>
      </form>

      <!-- ヴァリデーションチェックメッセージエリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="!ruleCheckFlag.length || !a201ApplicationInputForm.valid">
        <label class="warning platform-warning-text">
          未入力の項目、またはエラーがあります。
        </label>
      </div>
      <!-- 余白エリア -->
      <div class="p-d-flex p-jc-center error-area" *ngIf="ruleCheckFlag.length && a201ApplicationInputForm.valid">
        <label class="warning platform-warning-text">
          &nbsp;
        </label>
      </div>


      <!-- ボタンエリア -->
      <div class="p-d-flex p-jc-center button-area">
        <button pButton type="button" label="確認画面へ進む" class="button-default-size button1" (click)="moveA202()"
          [disabled]="!ruleCheckFlag.length || !a201ApplicationInputForm.valid"></button>
      </div>
    </div>

    <!------------------------------------------------------------------------->

    <!-- 入会申請確認(A202) -->
    <div *ngIf="confirmationFlag">
      <!-- タイトル -->
      <div class="title">
        <h1>確認画面</h1>
      </div>

      <!-- 注意テキスト -->
      <div class="a202-warningText">
        下記内容でよろしければ、「登録する」ボタンを押してください<br />
        ※入会審査後、本申請に記載されたメールアドレス宛てに審査結果の通知メールが届きます。<br />
        ※入会審査には1週間程度かかる場合があります。
      </div>

      <!-- 申請情報 -->
      <div class="application-information confirmation-Form">
        <!-- 申請内容 -->
        <p-table [value]="[{}]" styleClass="information-Form">
          <ng-template pTemplate="body">
            <!-- 会員種別 -->
            <tr>
              <td class="item-input-name">会員種別</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ getDicName(1, a201ApplicationInputForm.value.class_id) }}
              </td>
            </tr>
            <!-- 団体名称 -->
            <tr>
              <td class="item-input-name">団体名称</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.organization_name }}
              </td>
            </tr>
            <!-- 団体名称フリガナ -->
            <tr>
              <td class="item-input-name">団体名称フリガナ</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.organization_kana }}
              </td>
            </tr>
            <!-- 法人番号(13裄) -->
            <tr>
              <td class="item-input-name">
                法人番号(13裄)
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.organization_no }}
              </td>
            </tr>
            <!-- 郵便番号 -->
            <tr>
              <td class="item-input-name">
                郵便番号
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.postal_no }}
              </td>
            </tr>

            <!-- 都道府県 -->
            <tr>
              <td class="item-input-name">
                都道府県
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <div>{{ a201ApplicationInputForm.value.prefectures }}</div>
              </td>
            </tr>

            <!-- 所在地（市区町村） -->
            <tr>
              <td class="item-input-name">
                所在地（市区町村）
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                <div>{{ a201ApplicationInputForm.value.city }}</div>
              </td>
            </tr>

            <!-- 所在地（町域） -->
            <tr>
              <td class="item-input-name">
                所在地（町域）
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.town_area }}
              </td>
            </tr>

            <!-- 所在地（番地・建物） -->
            <tr>
              <td class="item-input-name">
                所在地（番地・建物）
                <span class="required">【必須】</span>
              </td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.address_building }}
              </td>
            </tr>
            <!-- 業種 -->
            <tr>
              <td class="item-input-name">業種</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ getDicName(2, a201ApplicationInputForm.value.industry_id) }}
              </td>
            </tr>
            <!-- 団体ウェブサイトURL -->
            <tr>
              <td class="item-input-name">ウェブサイトURL</td>
              <td class="item-label-name">
                <p-tag value="公開" styleClass="public-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.url }}
              </td>
            </tr>
            <!-- 部局名 -->
            <tr>
              <td class="item-input-name">部局名</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.department_name }}
              </td>
            </tr>
            <!-- 課室名 -->
            <tr>
              <td class="item-input-name">課室名</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.division_name }}
              </td>
            </tr>
            <!-- 役職 -->
            <tr>
              <td class="item-input-name">役職</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.jobposition_name }}
              </td>
            </tr>
            <!-- 氏名 -->
            <tr>
              <td class="item-input-name">氏名</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.full_name }}
              </td>
            </tr>
            <!-- 電話番号 -->
            <tr>
              <td class="item-input-name">電話番号</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.tel }}
              </td>
            </tr>
            <!-- eメールアドレス -->
            <tr>
              <td class="item-input-name">eメールアドレス</td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">
                {{ a201ApplicationInputForm.value.email }}
              </td>
            </tr>
            <!-- 2020プラットフォーム誓約書 -->
            <tr>
              <td class="item-input-name">プラットフォーム誓約書<br /></td>
              <td class="item-label-name">
                <p-tag value="非公開" styleClass="private-tag"></p-tag>
              </td>
              <td class="item-information">{{ fileName }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <div class="information-margin"></div>

      <!-- アンケート情報 -->
      <div class="a202-question-information">
        <!-- アンケートタイトル -->
        <div class="question-title">
          <h1>入会時アンケート</h1>
        </div>

        <div class="question-margin"></div>

        <!-- アンケート内容 -->
        <div class = "confirmation-Form">
          <p-table [value]="[{}]" styleClass="information-Form">
            <ng-template pTemplate="body">
              <!-- （1）本プラットフォームを知った・・・ -->
              <tr>
                <td class="item-name">
                  （1）本プラットフォームを知った、または加入を希望したきっかけは何ですか。
                </td>
                <td class="item-information">
                  <div *ngFor="
                      let dicName of getDicNameList(
                        801,
                        a201ApplicationInputForm.value.questionary1
                      )
                    ">
                    {{ dicName.sp_order }}.{{ dicName.sp_name }}
                  </div>
                  {{ a201ApplicationInputForm.value.questionary1_other }}
                </td>
              </tr>
              <!-- （2）本プラットフォームへの加入を希望する・・・ -->
              <tr>
                <td class="item-name">
                  （2）本プラットフォームへの加入を希望する理由および本プラットフォームに期待することは何ですか。
                </td>
                <td class="item-information">
                  <div *ngFor="
                      let dicName of getDicNameList(
                        802,
                        a201ApplicationInputForm.value.questionary2
                      )
                    ">
                    {{ dicName.sp_order }}.{{ dicName.sp_name }}
                  </div>
                  {{ a201ApplicationInputForm.value.questionary2_other }}
                </td>
              </tr>
              <!-- （3）本プラットフォームでは地方公共団体が抱える課題に対し・・・ -->
              <tr>
                <td class="item-name">
                  （3）本プラットフォームでは地方公共団体が抱える課題に対し、協働で考え取り組む民間団体等と連携することを目的としたマッチング支援を実施しています。
                  マッチングについて、どのような方法を希望しますか。
                </td>
                <td class="item-information">
                  <div *ngFor="
                      let dicName of getDicNameList(
                        803,
                        a201ApplicationInputForm.value.questionary3
                      )
                    ">
                    {{ dicName.sp_order }}.{{ dicName.sp_name }}
                  </div>
                  {{ a201ApplicationInputForm.value.questionary3_other }}
                </td>
              </tr>
              <!-- （4）地方創生SDGs官民連携プラットフォーム以外に、・・・ -->
              <tr>
                <td class="item-name">
                  （4）地方創生SDGs官民連携プラットフォーム以外に、他の官民連携マッチングプラットフォームやサービスに加入・利用していますか。
                </td>
                <td class="item-information">
                  <div>
                    {{
                    getDicName(804, a201ApplicationInputForm.value.questionary4)
                    }}
                  </div>
                  {{ a201ApplicationInputForm.value.questionary4_other }}
                </td>
              </tr>
              <!-- （5）本プラットフォームでは、会員間の共通の問題や課題に対する課題の検討の実施・・・ -->
              <tr>
                <td class="item-name">
                  （5）上記問（４）にて他プラットフォーム・サービスに加入していると回答した場合（選択肢1.又は2.）、加入・利用している理由は何ですか。
                </td>
                <td class="item-information">
                  <div *ngFor="
                      let dicName of getDicNameList(
                        805,
                        a201ApplicationInputForm.value.questionary5
                      )
                    ">
                    {{ dicName.sp_order }}.{{ dicName.sp_name }}
                  </div>
                  {{ a201ApplicationInputForm.value.questionary6 }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        <!-- 余白エリア -->
        <div class="p-d-flex p-jc-center error-area">
          <label class="warning platform-warning-text">
            &nbsp;
          </label>
        </div>

        <!-- ボタンエリア -->
        <div class="p-d-flex p-jc-center button-area">
          <button pButton type="button" label="登録する" class="button-default-size button1" (click)="moveA203()"></button>
          <button pButton type="button" label="修正する" class="button-default-size button2" (click)="moveA201()"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 共通部品_郵便番号ダイアログ -->
<app-postal-no-dialog (returnPostalNoData)="setPostalNo($event)"></app-postal-no-dialog>

<!-- フッダー -->
<footer>
  <app-footer></app-footer>
</footer>
